import React from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";

interface Props {
    title: string;
    description: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

function CreateTagDialog({ title, description, open, onConfirm, onClose }: Props) {
    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        {title}
                    </DialogTitle>
                    <div>{description}</div>
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Yes" onClick={onConfirm} />
                        <SecondaryButton label="No" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CreateTagDialog;
